import React from "react";

const PromotoableProfVideo = ({ subsection, saveProgress }) => {
  const about = (
    <div className="space-y-5 pt-2 pb-6 text-body leading-7 text-[#484848]">
      <p>
      This lesson shifts focus from effort to control. It examines why most professionals plateau despite meeting expectations and introduces the idea of a “Promotable Professional” — someone who shapes opportunity instead of waiting for it. These people focus on what they can influence: building trust, reading stakeholders, managing energy, and staying visible. They don’t wait for luck or timing; they build the conditions that make promotion inevitable.
      </p>

      
    </div>
  );

  const transcriptHtml = `
    <p>Every year, millions of people work hard, meet expectations, and still don't move forward.</p>

    <p>Not because they failed.</p>

    <p>But because they focused on things they couldn't control.</p>

    <p>According to reports, out of 68 million white-collar workers in the United States, <strong>98.7% did not earn a promotion.</strong></p>

    <p><strong>What went wrong?</strong></p>

    <p>The real question is what did the <strong>1.3%</strong> do right?</p>

    <p>Because promotions aren't accidents; they're patterns of behavior.</p>

    <p>A lot depends on open positions, restructuring, health of business, market conditions and so on. You can't control these things.</p>

    <p>But there's something you can control, and that's what promotable professionals double down on.</p>

    <h3 style="margin-top: 24px; margin-bottom: 12px; font-weight: 700; font-size: 1.125rem;">How do you define a Promotable Professional?</h3>

    <h4 style="margin-top: 16px; margin-bottom: 8px; font-weight: 600; font-size: 1rem;">Promotable Professional</h4>

    <p>Is the one with a higher probability of getting promoted, a person who moves up faster than others. They are first among equals, the same skill set, the same team but always one step ahead.</p>

    <p>They are the ones that don't worry about the things beyond their control but leverage what they can control. And they do it well too.</p>

    <p><strong>Promotable professionals don't wait for the right time, they create it.</strong></p>

    <p>They ask early, choose their work wisely, and understand not just what their stakeholders need, but what they want.</p>

    <p>They build a personal brand that speaks for them, seek feedback that shapes them, and protect their energy so they can stay consistent, not just busy.</p>

    <p>If being promotable starts with awareness, growth begins with control.</p>

    <p><strong>Do you think you are promotable?</strong></p>
  `;

  const transcript = (
    <div
      className="pt-2 pb-6 text-body leading-7 text-[#484848] max-w-2xl"
      dangerouslySetInnerHTML={{ __html: transcriptHtml }}
    />
  );

  // const relatedLinks = (
  //   <div className="pt-2 pb-6">
  //     <ul className="list-disc list-inside text-body space-y-2">
  //       <li>
  //         <button type="button" className="text-link">
  //           Download Slides
  //         </button>
  //       </li>
  //       <li>
  //         <button type="button" className="text-link">
  //           Reference Reading: Career Transitions Report 2025
  //         </button>
  //       </li>
  //     </ul>
  //   </div>
  // );

  const notes = (
    <div className="pt-2 pb-6">
      <textarea
        rows={4}
        placeholder="Write your notes here..."
        className="w-full border border-gray-200 rounded-xl p-3 text-body focus:ring-2 focus:ring-brand/40 focus:outline-none"
        onBlur={(e) => saveProgress("in_progress", { notes: e.target.value })}
      />
    </div>
  );

  return { about, transcript, notes };
};

export default PromotoableProfVideo;

